(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFaq(root) {
      if (!root || root.dataset.claFaqInit === '1') return;
      root.dataset.claFaqInit = '1';
      var triggers = root.querySelectorAll('[data-cla-faq-trigger]');
      triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var item = trigger.closest('.cla-faq__item');
          var panel = document.getElementById(trigger.getAttribute('aria-controls'));
          if (!item || !panel) return;
          var isOpen = item.classList.contains('is-open');
          root.querySelectorAll('.cla-faq__item.is-open').forEach(function (openItem) {
            if (openItem !== item) {
              openItem.classList.remove('is-open');
              var t = openItem.querySelector('[data-cla-faq-trigger]');
              var p = openItem.querySelector('.cla-faq__panel');
              if (t) t.setAttribute('aria-expanded', 'false');
              if (p) p.setAttribute('hidden', '');
            }
          });
          if (isOpen) { item.classList.remove('is-open'); trigger.setAttribute('aria-expanded', 'false'); panel.setAttribute('hidden', ''); }
          else { item.classList.add('is-open'); trigger.setAttribute('aria-expanded', 'true'); panel.removeAttribute('hidden'); }
        });
      });
    }
    document.querySelectorAll('[data-cla-faq]').forEach(initFaq);
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('[data-cla-faq]');
      if (section) initFaq(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
